export { CheckResult } from "@regulaforensics/document-reader-webclient";

export const RfidLocation = {
  NONE: 0,
  MAIN_PAGE: 1,
  BACK_PAGE: 2,
};
